import { useState, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { scroller } from "react-scroll";
import { useParams, useHistory } from "react-router-dom";
import logoHeader from "../../assets/logo.png";
import { useLocation } from "react-router-dom";
import { useWhatsAppConsulta } from "../../config/WhatsAppConsultaContext";
import { getFirestore } from "../../config/firebase";
import { collection, docs, getDocs } from "firebase/firestore";
import { buildRouteWithUtms } from "../../config/whatsappConfig";

const NAV_ITEMS = [
  { label: "Inicio", sectionId: "inicio", route: "/todos" },
  { label: "Venta Directa", sectionId: "convencional", route: "/convencional" },
  { label: "Financiaciones", sectionId: "financiaciones", route: "/convencional" },
  { label: "Plan de ahorro", sectionId: "plan", route: "/plan" },
];

const Header = ({ vehicles }) => {
  // const [vehicles, setVehicles] = useState([]);
  // const db = getFirestore();

  // useEffect(() => {
  //   const cargarVehiculos = async () => {
  //     // Verificar si los datos ya están en localStorage
  //     const datosLocales = sessionStorage.getItem("vehicles");
  //     if (datosLocales) {
  //       // Parsear los datos de localStorage y establecerlos en el estado
  //       setVehicles(JSON.parse(datosLocales));
  //     } else {
  //       // Si no están en localStorage, obtenerlos de Firebase
  //       try {
  //         const querySnapshot = await db.collection("ford").get();
  //         const arrayVehicles = querySnapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
  //         setVehicles(arrayVehicles);
  //         // Almacenar los datos en localStorage
  //         sessionStorage.setItem("vehicles", JSON.stringify(arrayVehicles));
  //       } catch (error) {
  //         console.log(error);
  //       }
  //     }
  //   };

  //   // Llamar a la función para cargar datos
  //   cargarVehiculos();
  // }, [db]);

  const { openConsultaForm } = useWhatsAppConsulta();

  let location = useLocation();

  const [tipoSearch, setTipoSearch] = useState("todos");
  const [tipoToUse, setTipoToUse] = useState("todos");
  const [filtrados, setFiltrados] = useState(vehicles);

  let history = useHistory();
  let { tipo } = useParams();

  useEffect(() => {
    const validTipos = ["todos", "convencional", "plan", "preventa"];
    const search = location.search;

    if (!tipo || !validTipos.includes(tipo)) {
      history.replace(buildRouteWithUtms("/todos", search));
    }
  }, []);

  useEffect(() => {
    if (tipo === undefined) {
      setTipoToUse("todos");
    } else {
      setTipoToUse(tipo);
    }
  }, [tipo]);

  useEffect(() => {
    setTipoSearch(tipoToUse);
  }, [tipoToUse]);

  //FILTRAR LOS VEHICULOS
  useEffect(() => {
    if (tipoSearch === "preventa") {
      setFiltrados(vehicles.filter((item) => item?.preventa?.habilitado === true));
    }

    if (tipoSearch === "plan") {
      setFiltrados(vehicles.filter((item) => item.plan.habilitado === true));
    }

    if (tipoSearch === "convencional") {
      setFiltrados(vehicles.filter((item) => item.convencional.habilitado === true));
    }

    if (tipoSearch === "todos") {
      setFiltrados(vehicles);
    }
  }, [tipoSearch, vehicles]);

  window.dataLayer = window.dataLayer || [];

  const handlePedirPresupuesto = () => {
    window.dataLayer.push({
      event: "solicitud_presupuesto",
    });

    openConsultaForm();
  };

  const handleNavClick = ({ sectionId, route }) => {
    const search = location.search;
    const currentTipo = tipo || "todos";
    const targetTipo = route.replace("/", "") || "todos";

    if (currentTipo !== targetTipo) {
      history.push(buildRouteWithUtms(route, search));
    }

    setTimeout(() => {
      scroller.scrollTo(sectionId, { smooth: true, duration: 500, offset: -10 });
    }, currentTipo !== targetTipo ? 350 : 0);
  };

  return (
    <Container fluid className="header">
      <Container>
        <Row className="row-header">
          <Col lg={3} md={4} xs={12} className="text-sm-start text-center py-2">
            <Link to={buildRouteWithUtms("/todos", location.search)}>
              <img src={logoHeader} alt="Montironi Ford" className="header-logo" />
            </Link>
          </Col>
          <Col
            lg={9}
            md={8}
            xs={12}
            className="text-sm-start text-center py-2 justify-content-md-end justify-content-center d-md-flex d-none"
          >
            <nav className="header-nav" aria-label="Navegación principal">
              {NAV_ITEMS.map((item) => (
                <button
                  key={item.sectionId}
                  type="button"
                  className="link-header border-0 bg-transparent"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleNavClick(item)}
                >
                  {item.label}
                </button>
              ))}

              <Button className="btn-ford-corporate ms-md-2" onClick={() => handlePedirPresupuesto()}>
                Solicitar cotización
              </Button>
            </nav>
          </Col>
        </Row>
      </Container>
      {/* ModalContacto + Formulario: conservados en el repo, desactivados en favor del form WhatsApp */}
    </Container>
  );
};

export default Header;
